var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.18182C1.88727 3.39273 6.54545 0 12 0C17.4545 0 22.1127 3.39273 24 8.18182C22.1127 12.9709 17.4545 16.3636 12 16.3636C6.54545 16.3636 1.88727 12.9709 0 8.18182ZM21.622 8.18182C19.822 4.50546 16.1347 2.18182 12.0002 2.18182C7.86565 2.18182 4.17837 4.50546 2.37837 8.18182C4.17837 11.8582 7.86565 14.1818 12.0002 14.1818C16.1347 14.1818 19.822 11.8582 21.622 8.18182ZM12 5.45455C13.5055 5.45455 14.7273 6.67636 14.7273 8.18182C14.7273 9.68727 13.5055 10.9091 12 10.9091C10.4945 10.9091 9.27273 9.68727 9.27273 8.18182C9.27273 6.67636 10.4945 5.45455 12 5.45455ZM7.09091 8.18182C7.09091 5.47636 9.29455 3.27273 12 3.27273C14.7055 3.27273 16.9091 5.47636 16.9091 8.18182C16.9091 10.8873 14.7055 13.0909 12 13.0909C9.29455 13.0909 7.09091 10.8873 7.09091 8.18182Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.11f319ee1b77a156e76478151fbc3602.svg";
export { ForwardRef as ReactComponent };